import { LinkButton } from '@kk/ui/components/Button';
import { Icon, type IconType } from '@kk/ui/components/Icon';
import { cn } from 'cn';
import { useTranslation } from 'react-i18next';
import { NavLink } from 'react-router-dom';
import type { allPaths } from '#/routes';
import { generateUrl } from './generateUrl';

const labelClassName =
  'h-full whitespace-nowrap transition-opacity delay-200 duration-150 group-focus-within:opacity-100 group-focus-within:delay-0 group-hover:opacity-100 group-hover:delay-0 lg:opacity-0';

/**
 * @url https://kommunekredit.visualstudio.com/KK%20Laaneportal/_wiki/wikis/KK-Laaneportal.wiki/1920/Sidenavigation
 */
export const NavigationLinks = () => {
  const { t } = useTranslation();

  const links = [
    {
      icon: 'home',
      title: t('navigation.home'),
      to: '/',
    },
    {
      icon: 'loan-alt',
      title: t('navigation.contracts'),
      to: `/aftaler`,
    },
    {
      icon: 'document',
      title: t('navigation.annualReports'),
      to: `/aarsopgoerelser`,
    },
    {
      icon: 'signature',
      title: t('navigation.signature'),
      to: `/underskriftsrum`,
    },
    {
      icon: 'organization',
      title: t('navigation.organization'),
      to: `/organisation`,
    },
  ] satisfies {
    icon: IconType;
    title: string;
    to: (typeof allPaths)[number];
  }[];

  return (
    <ul role="menu" className="text-blue-60 flex w-full flex-col gap-4">
      {links.map((link, index) => (
        <li key={`item-${index}`}>
          <NavLink
            title={link.title}
            to={link.to}
            className="typ-body group/link block rounded-md aria-disabled:pointer-events-none"
            onClick={(e) => {
              // add focus to main based on const navigation = useNavigation(); const isNavigating = Boolean(navigation.location);
              e.currentTarget.blur();
            }}
          >
            {({ isActive }) => (
              <div
                className={cn(
                  'flex size-full items-center justify-start rounded-md p-4 hover:cursor-pointer md:justify-start',
                  isActive
                    ? 'bg-blue-10 hover:bg-blue-20 group-focus/link:bg-blue-20 text-blue-100'
                    : 'hover:bg-blue-10 group-focus/link:bg-blue-10 bg-transparent',
                )}
              >
                <Icon
                  type={link.icon}
                  size="small"
                  solid
                  className="shrink-0"
                />
                <span
                  className={cn(
                    'pl-2',
                    labelClassName,
                    isActive ? 'text-blue-100' : 'text-blue-60',
                  )}
                >
                  {link.title}
                </span>
              </div>
            )}
          </NavLink>
        </li>
      ))}
      <li>
        <LinkButton
          to={generateUrl('/beregner', {})}
          icon="plus"
          iconProps={{
            size: 'small',
          }}
          theme="primary"
          className="kunde:h-14 p-4 max-lg:pr-6 max-lg:w-fit"
        >
          <span className={labelClassName}>{t('navigation.calculator')}</span>
        </LinkButton>
      </li>
    </ul>
  );
};
